import React from 'react';
import { FadeIn } from './FadeIn';
import { Check, X } from 'lucide-react';
export function AudienceSection() {
  const forWho = ['Parents of teens (15-19) or college students who are "tech-obsessed" but directionless.', 'Parents who want to teach their kids financial literacy and the value of a dollar.', 'Teenagers who want to earn money from home using only their smartphones.', 'Families looking for a productive way to bridge the gap between digital habits and real-world income.'];
  const notForWho = ['Parents looking for a "get rich quick" scheme that requires zero effort from the teen.', 'People who want to build a "viral" influencer brand (this is about steady, local service income).', 'Anyone unwilling to let their teen take lead on the creative work.'];
  return <section className="bg-white py-24 px-6 border-y border-brand-navy/5" data-id="element-14">
      <div className="max-w-5xl mx-auto" data-id="element-15">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-16">
          {/* WHO THIS IS FOR */}
          <FadeIn data-id="element-17">
            <div className="bg-brand-cream p-8 md:p-10 rounded-3xl h-full" data-id="element-18">
              <h3 className="text-2xl md:text-3xl font-bold text-brand-navy mb-8 flex items-center" data-id="element-19">
                Who This Is For
              </h3>
              <ul className="space-y-6" data-id="element-20">
                {forWho.map((item, index) => <li key={index} className="flex items-start" data-id="element-21">
                    <div className="flex-shrink-0 mt-1" data-id="element-22">
                      <Check className="w-6 h-6 text-brand-teal" data-id="element-23" />
                    </div>
                    <span className="ml-4 text-lg text-brand-gray leading-relaxed" data-id="element-24">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* WHO THIS IS NOT FOR */}
          <FadeIn delay={0.2} data-id="element-25">
            <div className="bg-red-50 p-8 md:p-10 rounded-3xl h-full" data-id="element-26">
              <h3 className="text-2xl md:text-3xl font-bold text-brand-navy mb-8 flex items-center" data-id="element-27">
                Who This Is NOT For
              </h3>
              <ul className="space-y-6" data-id="element-28">
                {notForWho.map((item, index) => <li key={index} className="flex items-start" data-id="element-29">
                    <div className="flex-shrink-0 mt-1" data-id="element-30">
                      <X className="w-6 h-6 text-red-500" data-id="element-31" />
                    </div>
                    <span className="ml-4 text-lg text-brand-gray leading-relaxed" data-id="element-32">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}